import React, { Component } from "react";

import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import moment from "moment";
import TransferOrderProductsTable from "./TransferOrderProductsTable";
import { Button, Dropdown, Menu, message } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import instance from "@/store/actions/instance";

class TransferOrderInvoice extends Component {
  printIframe = async (type) => {
    const { t, selectedOrder } = this.props;
    this.setState({ invoicesLoading: true });
    try {
      const invoice = await instance.get(
        `transfer/invoice/${type}/${selectedOrder.id}`,
      );
      const iframe = document.frames
        ? document.frames["printingIframe"]
        : document.getElementById("printingIframe");
      iframe.srcdoc = invoice.data;
    } catch (e) {
      console.error(e);
      message.error(t("SomethingWentWrong"));
      this.setState({ invoicesLoading: false });
      return false;
    }
  };
  render() {
    const {
      t,
      selectedOrder,
      products,
      config,
      isReceiving,
      editMode,
      isViewOnly,
    } = this.props;
    const printMenu = (
      <Menu>
        <Menu.Item key="1" onClick={() => this.printIframe("order")}>
          {t("Transfer Order")}
        </Menu.Item>
        <Menu.Item key="2" onClick={() => this.printIframe("receiving_note")}>
          {t("Receiving Note")}
        </Menu.Item>
      </Menu>
    );
    return (
      <div
        className="jumbotron bg-white p-0 mt-4"
        style={{ paddingTop: 20, minWidth: 320 }}
      >
        <div className="my-3 " style={{ display: "flex", gap: 12 }}>
          <iframe
            id="printingIframe"
            style={{ display: "none" }}
            title="Receipt"
            onLoad={() => {
              const iframe = document.frames
                ? document.frames["printingIframe"]
                : document.getElementById("printingIframe");
              if (!this.state.invoicesLoading || !iframe.srcdoc) return;

              const iframeWindow = iframe.contentWindow || iframe;
              iframe.focus();
              iframeWindow.print();
              this.setState({ invoicesLoading: false });
            }}
          />
          <Dropdown overlay={printMenu}>
            <Button icon={<PrinterOutlined style={{ fontSize: 19 }} />}>
              {t("Print")}
            </Button>
          </Dropdown>
        </div>
        <h5>{t("Invoice")}</h5>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{
              display: "flex",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Tracking Code")}:
            </span>
            <span>{selectedOrder.tracking_id}</span>
          </div>
          <div
            style={{
              display: "flex",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Placed")}:
            </span>
            <span>
              {moment(selectedOrder.created).format("MMM Do YYYY - h:mm a")} -{" "}
              {t("by ")}
              {selectedOrder.created_by__username}
            </span>
          </div>

          <div
            style={{
              display: "flex",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Sent Date")}:
            </span>
            <span>
              {selectedOrder.sent_date
                ? `${moment(selectedOrder.sent_date).format(
                    "MMM Do YYYY - h:mm a",
                  )} - ${t("by")} ${selectedOrder.sent_by__username}`
                : "-"}
            </span>
          </div>
          <div
            style={{
              display: "flex",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Received Date")}:
            </span>
            <span>
              {selectedOrder.received_date
                ? `${moment(selectedOrder.received_date).format(
                    "MMM Do YYYY - h:mm a",
                  )} - ${t("by")} ${selectedOrder.received_by__username}`
                : "-"}
            </span>
          </div>

          <div
            style={{
              display: "flex",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Cancelled Date")}:
            </span>
            <span>
              {selectedOrder.cancelled_date
                ? `${moment(selectedOrder.cancelled_date).format(
                    "MMM Do YYYY - h:mm a",
                  )} - ${t("by")} ${selectedOrder.cancelled_by__username}`
                : "-"}
            </span>
          </div>

          <div style={{ display: "flex" }}>
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Source Branch")}:
            </span>

            <span>
              {(config.language === "arabic" &&
                selectedOrder.from_branch__ar_name) ||
                selectedOrder.from_branch__name ||
                t("Central Storage Unit")}
            </span>
          </div>

          <div style={{ display: "flex" }}>
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Destination Branch")}:
            </span>

            <span>
              <span>
                {(config.language === "arabic" &&
                  selectedOrder.to_branch__ar_name) ||
                  selectedOrder.to_branch__name ||
                  t("Central Storage Unit")}
              </span>
            </span>
          </div>
        </div>
        <TransferOrderProductsTable
          isReceiving={isReceiving}
          setProducts={this.props.setProducts}
          products={products}
          selectedOrder={selectedOrder}
          isViewOnly={isViewOnly}
          editMode={editMode}
          setEditMode={this.props.setEditMode}
          setLoading={this.props.setLoading}
          fetchTransferOrderDetails={this.props.fetchTransferOrderDetails}
        />

        {selectedOrder.notes && (
          <>
            <h6>Note:</h6>
            <p>{selectedOrder.notes}</p>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
    settings: state.auth.settings,
    config: state.config,
    is_staff: state.auth.is_staff,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(TransferOrderInvoice));
